module.exports = __webpack_public_path__ + "static/img/otherbg.ef5d54a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/otherbg.png
// module id = tu9E
// module chunks = 1